var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVidoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0039 8.00391C20.8402 8.00391 17.7475 8.94206 15.117 10.6997C12.4864 12.4574 10.4362 14.9557 9.22545 17.8786C8.01474 20.8015 7.69797 24.0177 8.31518 27.1207C8.93239 30.2236 10.4559 33.0738 12.693 35.3109C14.9301 37.548 17.7803 39.0715 20.8832 39.6887C23.9862 40.3059 27.2024 39.9892 30.1253 38.7785C33.0482 37.5677 35.5465 35.5175 37.3042 32.8869C39.0618 30.2564 40 27.1637 40 24C39.9947 19.7592 38.3077 15.6936 35.309 12.6949C32.3103 9.69619 28.2447 8.0092 24.0039 8.00391ZM29.6087 25.0244L22.2259 29.9462C22.0234 30.0804 21.7859 30.1521 21.543 30.1523C21.2166 30.1523 20.9037 30.0227 20.6729 29.7919C20.4421 29.5612 20.3125 29.2482 20.3125 28.9219V19.0781C20.3124 18.8553 20.3727 18.6366 20.4871 18.4454C20.6016 18.2542 20.7658 18.0977 20.9622 17.9925C21.1586 17.8874 21.38 17.8375 21.6025 17.8483C21.8251 17.8591 22.0405 17.9301 22.2259 18.0538L29.6087 22.9756C29.7775 23.088 29.9159 23.2402 30.0116 23.4189C30.1074 23.5977 30.1574 23.7973 30.1574 24C30.1574 24.2027 30.1074 24.4023 30.0116 24.581C29.9159 24.7598 29.7775 24.912 29.6087 25.0244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidoicon);
export default __webpack_public_path__ + "static/media/vidoicon.48b5991e90b10fe894c0132c52f1ba33.svg";
export { ForwardRef as ReactComponent };